export default __webpack_public_path__ + "static/media/9_Icon.51824bf8.png";